import { Card } from '@/components/ui/card';
import { Star } from 'lucide-react';

interface RatingsCardProps {
  rating: number;
  totalReviews: number;
  ratingBreakdown: Array<{
    stars: number;
    percentage: number;
  }>;
  recentReview: {
    rating: number;
    comment: string;
    author: string;
    date: string;
  };
}

export function RatingsCard({
  rating,
  totalReviews,
  ratingBreakdown,
  recentReview
}: RatingsCardProps) {
  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Avaliações</h2>

      {/* Overall Rating */}
      <div className="text-center mb-6">
        <div className="text-4xl font-bold text-blue-600">{rating.toFixed(1)}</div>
        <div className="flex justify-center mt-2">
          {[1, 2, 3, 4, 5].map((star) => (
            <Star
              key={star}
              className={`w-5 h-5 ${
                star <= rating
                  ? 'text-yellow-400 fill-yellow-400'
                  : 'text-gray-300'
              }`}
            />
          ))}
        </div>
        <p className="text-sm text-gray-600 mt-1">
          Baseado em {totalReviews} avaliações
        </p>
      </div>

      {/* Rating Breakdown */}
      <div className="space-y-2">
        {ratingBreakdown.map(({ stars, percentage }) => (
          <div key={stars} className="flex items-center gap-2">
            <div className="flex items-center gap-1 w-24">
              <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
              <span className="text-sm">{stars}</span>
            </div>
            <div className="flex-1 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div
                className="h-full bg-blue-600 rounded-full"
                style={{ width: `${percentage}%` }}
              />
            </div>
            <span className="text-sm text-gray-600 w-12">{percentage}%</span>
          </div>
        ))}
      </div>

      {/* Recent Review */}
      <div className="mt-6">
        <h3 className="font-semibold mb-2">Avaliação Recente</h3>
        <div className="bg-gray-50 rounded-lg p-4">
          <div className="flex items-center justify-between mb-2">
            <div className="flex items-center gap-2">
              {[1, 2, 3, 4, 5].map((star) => (
                <Star
                  key={star}
                  className={`w-4 h-4 ${
                    star <= recentReview.rating
                      ? 'text-yellow-400 fill-yellow-400'
                      : 'text-gray-300'
                  }`}
                />
              ))}
            </div>
            <span className="text-sm text-gray-500">{recentReview.date}</span>
          </div>
          <p className="text-gray-800 mb-2">{recentReview.comment}</p>
          <p className="text-sm text-gray-600">por {recentReview.author}</p>
        </div>
      </div>
    </Card>
  );
}